import { useState, useEffect } from "react";
import { Modal, Form, Input } from "antd";
import { mixGetV1, mixPutV1, mixPostV1,mixGetImage } from "services/mixin";


interface Profile {
    info: {
        date_update_password: string
    }
}
interface Password {
    old_password: string,
    new_password: string,
    confirm_password: string,
}

const Security = () => {

    const [isModalChangePass, setIsModalChangePass]=useState(false)
    const [isCorrectPass, setIsCorrectPass] = useState(false)
    const [isErrorPass, setIsErrorPass] = useState(false)
    const [profile, setProfile] = useState<Profile | null>(null)
    const [pass, setPass] = useState<Password | null>(null)

    // const handleSubmit = () => {
    //     setIsCorrectPass(true)
    // }

    const handleCanceChangePass = () => {
        setIsModalChangePass(false)
        setIsCorrectPass(false)
    }

    const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // tháng từ 0 → 11
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

// API
    const getProfile = async () => {
        const res = await mixGetV1('/api/v1/fe/customer/profile')

        if(res.status) {
            setProfile(res.data)
        }
    }
    const changePassword = async () => {
        if(pass?.new_password !== pass?.confirm_password){
            setIsErrorPass(true)
        }
        const param = {
            old_password: pass?.old_password,
            new_password: pass?.new_password,
            confirm_password: pass?.confirm_password,
        }
        try {
            const res = await mixPostV1('/api/v1/fe/customer/update_password',param)
            if(res.status) {
                setIsCorrectPass(true)
                setPass({ old_password: "", new_password: "", confirm_password: "" });
            }else {
                console.log(res.msg || "Something went wrong");
            }
        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        getProfile()
    }, [])

    return(
        <section className="card" id="security">
            <div className="card-header">
                <div className="title-card">Security</div>
            </div>
            <div className="card-detail">
                <div className="row">
                    <p className="label">Password</p>
                    <p className="value">
                        <input type="password" value={'**************'} disabled />
                    </p>
                    <div onClick={()=> setIsModalChangePass(true)} className="link">Change</div>
                </div>
                <div className="row">
                    <p className="label">Last Changed</p>
                    <p className="value">
                        <span>{ formatDate(profile?.info.date_update_password || '') }</span>
                        {/* <span> | </span>
                        <span>15:35 PM</span> */}
                    </p>
                </div>
            </div>
            <Modal
                title='Change Password'
                open={isModalChangePass}
                onCancel={handleCanceChangePass}
                className="modal-change-pass"
                footer={null}
                width={360}
            >
                <form className="content">
                    {isCorrectPass === false && (
                       <>
                            {isErrorPass? (
                                <div className="error">Password is not match</div>
                            ):
                            (
                                <span></span>
                            )
                            }
                            <Input.Password 
                                placeholder="Current Password"
                                value={pass?.old_password}
                                onChange={e => setPass(prev => ({ ...prev!, old_password: e.target.value }))} 
                            />
                            <Input.Password 
                                placeholder="New Password"
                                value={pass?.new_password}
                                onChange={e => setPass(prev => ({ ...prev!, new_password: e.target.value }))}
                            />
                            <Input.Password 
                                placeholder="Confirm Password"
                                value={pass?.confirm_password}
                                onChange={e => setPass(prev => ({ ...prev!, confirm_password: e.target.value }))}
                                />
                            <div onClick={changePassword} className="btn-primary">Change</div>
                       </>
                    )}
                    {isCorrectPass && (
                        <>
                            <svg
                                className="check-icon"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z" fill="currentColor"></path>
                            </svg>
                            <p style={{ fontSize: 16 }}>Your password has been changed.</p>
                            <div onClick={handleCanceChangePass} className="btn-primary">Change</div>
                        </>
                    )

                    }
                </form>
            </Modal>
        </section>
    )
}

export default Security;